// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-wrapper[data-v-c08388f0]{overflow:auto}", "",{"version":3,"sources":["webpack://./src/features/modals/ReferenceTextModal.scoped.scss"],"names":[],"mappings":"AAAA,+BAA+B,aAAa","sourcesContent":[".text-wrapper[data-v-c08388f0]{overflow:auto}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
